// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"37a86f59","839":"2203ef1f"}[chunkId] + ".chunk.js";
};